import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {NoteCommentsModel} from "./note-comments.model";

@Injectable()
export class NoteCommentsService {

    private API_ROOT:string = '/sales-notes/comments';

    constructor(private http:Http) {
    }


    getListByNote(noteId:number, filter?:IDataFilter): Observable<ListResponseModel<NoteCommentsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/sales-notes/${noteId}/comments`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }
    
    add(fields:NoteCommentsModel): Observable<ResponseModel<NoteCommentsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/models/note-comments/note-comments.service.ts